export default "__VITE_ASSET__DofYfOF0__"